import { generalInfo } from 'shared/constants/general-info';
import { baseTheme } from 'shared/themes/baseTheme';
import { IState } from '../shared/interfaces/state.interface';

export const initialStore: IState = {
  app: {
    appConfig: {
      appName: generalInfo.appName,
      companyUrl: generalInfo.companyUrl,
      logo: 'TelegraLogo',
      smallLogo: 'TelegraLogo',
      logoWithName: generalInfo.logoWithName,
      logoRedirectUrl: generalInfo.logoRedirectUrl
    },
    appTheme: baseTheme,
    whiteLabelAffiliate: null,
    affiliateStylesConfig: null,
    zohoDeskWidgetType: null
  },
  auth: {
    twoFactorType: null,
    message: null,
    twoFAOptions: null,
    isUserExisting: undefined,
    email: undefined,
    phone: undefined
  },
  user: {
    isLoading: false,
    data: null,
    currentVisit: null
  },
  channel: {
    isLoading: true,
    channels: []
  },
  conversation: {
    isLoading: true,
    conversationToken: '',
    selectedConversation: null,
    connectionRetryCount: 0
  },
  notifications: {
    isLoading: true,
    data: []
  },
  visits: {
    isLoading: true,
    data: [],
    currentVisit: null
  },
  orders: {
    isLoading: true,
    orderPaymentIsLoading: false,
    orders: [],
    currentOrder: null,
    paymentReservationFailed: false
  },
  labOrders: {
    isLoading: false,
    labOrders: [],
    currentLabOrder: null
  },
  ecommerce: {
    isLoading: true,
    ecommerceOrders: [],
    ecommerceCurrentOrder: null,
    ecommerceSubscriptions: [],
    ecommerceCurrentSubscription: null,
    loadingActionKey: null
  },
  tasks: {
    isLoading: true,
    data: []
  },
  onlineVisit: {
    isLoading: false,
    isLoadingForm: false,
    currentOrder: null,
    affiliate: null,
    questionnaireInstances: [],
    currentQuestionnaireInstance: null,
    availableStates: [],
    questionnaires: {
      questionnaires: [],
      answers: [],
      disableArray: [],
      questionnairesWereSet: false
    },
    possibleSymptoms: [],
    payments: {
      setupIntent: null,
      defaultPaymentMethod: null,
      availablePaymentMethods: [],
      isAttachedPaymentIntent: false,
      isAttachPaymentIntentFail: false
    },
    visitLink: '',
    validationError: false,
    availablePharmacies: [],
    potentialPharmacies: [],
    completeQuestionnaireInstance: null
  },
  patientNotes: {
    isLoading: true,
    data: []
  },
  billing: {
    availablePaymentMethods: [],
    defaultPaymentMethod: '',
    isLoading: true,
    setupIntent: null
  },
  patient: {
    data: null,
    educationFiles: [],
    isLoading: false
  },
  states: {
    allStates: [],
    isLoading: true
  },
  patientConversation: {
    data: null,
    isLoading: false,
    selectedChannel: null,
    unreadCount: 0
  },
  workflow: {
    isLoading: false,
    data: null,
    conversationId: null,
    execution: null,
    currentNode: null,
    messages: [],
    actionResult: null,
    isCompleted: false,
    isExecuting: false,
    isExisting: false,
    error: null,
    executionError: null
  }
};
